import { FlexBox, Typography } from '@vp/swan';
import React from 'react';
import { RawPrice } from '@vp/vp-tokenized-fragment';
import { useScopedBaseConfig } from './src-contexts-CouponCalloutConfig.context.js';
import { useLocalization } from './src-hooks-useLocalizations.js';
import { useCouponDetailsStore } from './src-store-couponDetails.store.js';
import { PromoBar } from './src-styledComponents-couponComponent.styles.js';
import { CouponCode } from './src-components-CouponDisplay-CouponCode.js';

const PriceDisplayMessage = ({ queryKey, asLowAsPrice }) => {
  const { t } = useLocalization();
  const { pageId, locale, tenant } = useScopedBaseConfig();
  const vatInclusivity = useCouponDetailsStore((state) => state.vatIncl);
  const couponDetails = useCouponDetailsStore((state) => state.data[pageId]?.couponDetails);
  const productCouponDetails = couponDetails?.productCouponData[queryKey];
  const productCouponPrice = productCouponDetails?.prices;
  const currency = couponDetails?.currency ?? "USD";
  const fractionDigits = couponDetails?.fractionDigits ?? 2;
  if (!productCouponDetails || !productCouponPrice) {
    return null;
  }
  const getPricingInfo = () => {
    const priceToBeConsidered = asLowAsPrice ? productCouponPrice.unitDiscountedPrice : productCouponPrice.discountedPrice;
    const taxedOrUntaxed = vatInclusivity ? "taxed" : "untaxed";
    const minimumFractionDigits = priceToBeConsidered?.taxed % 1 === 0 ? 0 : fractionDigits;
    return {
      listPrice: priceToBeConsidered[taxedOrUntaxed],
      discountPrice: priceToBeConsidered[taxedOrUntaxed],
      minimumFractionDigits,
      currency,
      culture: locale,
      vatInc: vatInclusivity,
      hideVatMessage: false
    };
  };
  return /* @__PURE__ */ React.createElement(PromoBar, null, /* @__PURE__ */ React.createElement(FlexBox, { flexWrap: "wrap", textAlign: "left", flexDirection: "row" }, /* @__PURE__ */ React.createElement(Typography, { fontWeight: "normal", margin: 0 }, t("coupon-callout.coupon-message-with-price", { price: /* @__PURE__ */ React.createElement(RawPrice, { pricingInfo: getPricingInfo(), tenant, placeHolderText: "" }) }), " | "), "\xA0", /* @__PURE__ */ React.createElement(Typography, null, /* @__PURE__ */ React.createElement(CouponCode, { queryKey }))));
};

export { PriceDisplayMessage };
//# sourceMappingURL=src-components-CouponDisplay-PriceDisplayMessage.js.map
